import {Component, OnInit, ViewChild} from '@angular/core';
import {ServiceSubject} from '../../../Models/ServiceSubject';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormGroup} from '@angular/forms';
import {ServiceSubjectService} from '../../../Services/service-subject.service';

@Component({
  selector: 'app-manage-service-subject',
  templateUrl: './manage-service-subject.component.html',
  styleUrls: ['./manage-service-subject.component.scss']
})
export class ManageServiceSubjectComponent implements OnInit {

  public serviceSubject: ServiceSubject = new ServiceSubject();
  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  public serviceSubjectId: number;
  public isEdit = false;
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;
  private isDone = true;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private serviceSubjectService: ServiceSubjectService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.serviceSubjectId = params['id'];
        this.isEdit = true;
        this.serviceSubjectService.getServiceSubject(this.serviceSubjectId).subscribe(resp => {
          const name = [];
          const description = [];
          resp.translations.forEach(item => {
            if (item.field === 'name') {
              name[item.locale] = item.content;
            }
            if (item.field === 'description') {
              description[item.locale] = item.content;
            }
          });

          resp.nameObj = name;
          resp.descriptionObj = description;

          resp.status = +resp.status;
          this.lastValue = {serviceSubject: resp};
          this.loadForm();
        });
      }
    });
    this.loadForm();
  }

  loadForm() {
    this.classicBox = <FormlyFieldConfig>[
      {
        fieldGroupClassName: 'row',
        key: 'serviceSubject',
        fieldGroup: [
          {
            className: 'col-6 ',
            type: 'input',
            key: 'nameObj.en',
            templateOptions: {
              label: this.translate.instant('doctrine.service_subject.subject_en'),
              required: true,
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                pattern: this.translate.instant('errors.invalid'),
                required: this.translate.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
              },
            },
          },
          {
            className: 'col-6 ',
            type: 'input',
            key: 'nameObj.nl',
            templateOptions: {
              label: this.translate.instant('doctrine.service_subject.subject_nl'),
              required: true,
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                pattern: this.translate.instant('errors.invalid'),
                required: this.translate.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
              },
            },
          },
        ],
      },
      {
        className: 'section-label',
        template: '<div><strong>' + this.translate.instant('admin.service_subject.description') + '</strong></div><hr />',
      },
      {
        fieldGroupClassName: 'row',
        key: 'serviceSubject',
        fieldGroup: [
          // {
          //   key: 'descriptionObj.en',
          //   type: 'editor',
          //   className: 'col-6 ',
          //   templateOptions: {
          //     label: this.translate.instant('doctrine.service_subject.description_en'),
          //     required: true,
          //     attributes: {
          //       toolsType: 'minimal',
          //       extraTools: 'link,btn-link'
          //     }
          //   }
          // },
          {
            key: 'descriptionObj.nl',
            type: 'editor',
            className: 'col-12 ',
            templateOptions: {
              label: this.translate.instant('doctrine.service_subject.description_nl'),
              required: true,
              attributes: {
                toolsType: 'normal',
                extraTools: 'link,btn-link'
              }
            }
          },
        ],
      },
      {
        fieldGroupClassName: 'row',
        key: 'serviceSubject',
        fieldGroup: [
          {
            key: 'thumbnail',
            type: 'file-uploader',
            className: 'col-6 ',
            templateOptions: {
              label: this.translate.instant('doctrine.service_subject.thumbnail'),
              description: this.translate.instant('validators.image'),
              attributes: {
                accept: '.png,.gif,.jpg',
                scope: 'backoffice',
                bupload: 'serviceSubject.thumbnail',
                fieldName: 'thumbnail'
              }
            }
          },
          {
            key: 'attachments',
            type: 'file-uploader',
            className: 'col-6 ',
            templateOptions: {
              label: this.translate.instant('doctrine.service_subject.attachments'),
              description: this.translate.instant('validators.file'),
              attributes: {
                accept: '.png,.gif,.jpg,.xls,.xlsx,.doc,.docx,.pdf',
                scope: 'backoffice',
                bupload: 'serviceSubject.attachments',
                queueLimit: 5,
                fieldName: 'attachments'
              }
            }
          },
        ],
      },
      {
        className: 'section-label',
        template: '<div><strong>' + this.translate.instant('admin.service_subject.other') + '</strong></div><hr />',
      },
      {
        fieldGroupClassName: 'row',
        key: 'serviceSubject',
        fieldGroup: [
          {
            key: 'status',
            type: 'ng-select',
            className: 'col-6',
            templateOptions: {
              multiple: false,
              label: this.translate.instant('doctrine.service_subject.status'),
              required: true,
              options: [{label: this.translate.instant('global.active'), value: 1}, {
                label: this.translate.instant('global.inactive'),
                value: 0
              }]
            },
          },
        ],
      },
    ];
  }

  public enableButton(event) {
    this.enableSave = event;
  }

  public submitItem(next: boolean) {
    if (next) {
      const serviceSubject = this.lastValue;

      const translations = [];

      for (const [key, value] of Object.entries(serviceSubject.serviceSubject.nameObj)) {
        translations.push({locale: key, field: 'name', content: value});
      }

      for (const [key, value] of Object.entries(serviceSubject.serviceSubject.descriptionObj)) {
        translations.push({locale: key, field: 'description', content: serviceSubject.serviceSubject.descriptionObj.nl});
      }

      const request = {
        translations: translations,
        status: serviceSubject.serviceSubject.status,
        thumbnail: serviceSubject.serviceSubject.thumbnail ? serviceSubject.serviceSubject.thumbnail.id : null,
        attachments: serviceSubject.serviceSubject.attachments ? serviceSubject.serviceSubject.attachments.map(attachment => attachment.id) : null,
      };

      this.serviceSubjectService.manageServiceSubject({serviceSubject: request}, this.isEdit, this.serviceSubjectId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/service/subject/overview');
      });

    } else {
      this.router.navigateByUrl('/back-office/service/subject/overview');
    }
  }

}
